import Immutable from 'seamless-immutable';
export var INITIAL_STATE = Immutable({
  selectedNodeId: null
});

/* eslint-disable */
export default function customerAccountHierarchyUiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    default:
      return state;
  }
}
/* eslint-enable */